import React from 'react';
import Card, { CardContent } from '../ui/Card';
import './Services.css';

const DebtRecovery = () => {
    const services = [{
            title: 'Early Stage Collections',
            description: 'Timely intervention for recent delinquencies'
        },
        {
            title: 'Late Stage Recovery',
            description: 'Intensive recovery for aged accounts'
        },
        {
            title: 'Skip Tracing',
            description: 'Advanced debtor location services'
        },
        {
            title: 'Payment Reminders',
            description: 'Systematic payment reminder campaigns'
        },
        {
            title: 'Negotiation & Settlement',
            description: 'Professional debt resolution support'
        },
        {
            title: 'Portfolio Recovery',
            description: 'Complete portfolio management solutions'
        }
    ];

    return ( <
        section className = "services-section" >
        <
        div className = "container" >
        <
        h2 className = "service-category-title" > Debt Collection & Recovery < /h2>

        <
        div className = "services-grid" > {
            services.map((service, index) => ( <
                Card key = { index } >
                <
                CardContent >
                <
                h3 > { service.title } < /h3> <
                p > { service.description } < /p> <
                /CardContent> <
                /Card>
            ))
        } <
        /div> <
        /div> <
        /section>
    );
};

export default DebtRecovery;